module.exports = __webpack_public_path__ + "static/media/book-open.03b60ee6.svg";